import { selectCurrUser } from '@/store/bootstrap/selectors';
import { useSelector } from 'react-redux';

export const useIsExternalUser = () => {
  const currUser = useSelector(selectCurrUser);
  if (currUser?.role === 'external_collaborator') return true;
  else return false;
};
